module.exports = __webpack_public_path__ + "static/img/logo.0553fce2.png";